import classNames from 'classnames';
import { ReactNode } from 'react';
const paneRootCss = "pk69pdr";
const paneHeaderCss = "pqimdnj";
const paneBodyCss = "p1knl3nf";
const paneFooterCss = "pk8olzh";
interface PaneSlotProps {
  children: ReactNode;
  className?: string;
}
interface PaneRootProps extends PaneSlotProps {
  'data-testid'?: string;
}
const Root = ({
  children,
  className,
  'data-testid': testId
}: PaneRootProps) => <div className={classNames(paneRootCss, className)} data-testid={testId}>
    {children}
  </div>;
const Header = ({
  children,
  className
}: PaneSlotProps) => <div className={classNames(paneHeaderCss, className)}>{children}</div>;
const Body = ({
  children,
  className
}: PaneSlotProps) => <div className={classNames(paneBodyCss, className)} data-testid="side-panel-pane-body">
    {children}
  </div>;
const Footer = ({
  children,
  className
}: PaneSlotProps) => <div className={classNames(paneFooterCss, className)}>{children}</div>;

/**
 * Header / body / footer column for side-panel panes (`#shell-side-panel`).
 * Body is the sole scroll region; keeps header chrome fixed while tab content scrolls.
 */
export const SidePanelPaneLayout = Object.assign(Root, {
  Header,
  Body,
  Footer
});

require("./SidePanelPaneLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SidePanelPaneLayout.tsx");